module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('a', {
    attrs: {
      "id": "epi"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "epiv"
  }, [_vm._v("Firm ground is not available ground.")]), _vm._v(" "), _c('div', {
    staticClass: "eps"
  }, [_c('i', [_vm._v("—A. R. Ammons")])]), _vm._v(" "), _c('div', {
    staticClass: "epiv"
  }, [_c('div', [_c('br')]), _c('div', [_c('br')]), _vm._v("I hear comments sometimes that large oil companies are greedy companies, or don’t care, but that is not the case in BP. We care about the small people.")]), _vm._v(" "), _c('div', {
    staticClass: "eps"
  }, [_c('i', [_vm._v("—Carl-Henric Svanberg, former chairman of BP")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-620fb8e2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/davi_9781571318398_oeb_epi_r1.vue
// module id = 72
// module chunks = 0